import { ChatRequest, ChatResponse, Message, Suggestion, EmailContentSection, EmailContentPreview, GenerateEmailRequest, GenerateEmailResponse, InitRequest, InitResponse } from '../types';

// Mock data for MIA Chat API testing
export const mockChatResponses: Record<string, ChatResponse> = {
  // Initial operation selection
  '0': {
    conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
    next_action: "SELECT_LEASE_OFFER",
    suggestions: [
      {
        id: "LO-001",
        text: "2025 Civic Sport"
      },
      {
        id: "LO-002",
        text: "2025 Accord LX"
      },
      {
        id: "LO-003",
        text: "2025 HR-V LX"
      },
      {
        id: "LO-004",
        text: "2025 CRV-Hybrid Sport"
      }
    ],
    is_input_restricted_to_suggestions: true,
    terminal_action: false,
    email_content_preview: [
      {
        subject: "Special Offer on Generate lease offer",
        sections: [
          {
            id: "GREETING",
            display_order: 1,
            title: null,
            content: "Dear [Customer Name],",
            variant: "default"
          },
          {
            id: "OPENING_MESSAGE",
            display_order: 2,
            title: null,
            content: "We have an exclusive offer on this Generate lease offer that might interest you.",
            variant: "default"
          },
          {
            id: "CTA_MESSAGE",
            display_order: 3,
            title: null,
            content: "Contact us today to schedule a test drive.",
            variant: "default"
          },
          {
            id: "FOOTER",
            display_order: 4,
            title: null,
            content: "Best regards,<br>Your Dealership Team",
            variant: "default"
          }
        ]
      }
    ],
    messages: [
      {
        role: "user",
        content: "Generate lease offer"
      },
      {
        role: "assistant",
        content: "Got it. I currently have lease offers for the following vehicles. Which one do you want to use it for?"
      }
    ]
  },

  // Lease offer selection
  'LO-001': {
    conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
    next_action: "CONFIRM_OPENING_MESSAGE",
    suggestions: [
      {
        id: "OM-001",
        text: "Looks good"
      },
      {
        id: "OM-002",
        text: "Regenerate"
      }
    ],
    is_input_restricted_to_suggestions: true,
    terminal_action: false,
    email_content_preview: [
      {
        subject: "Special Offer on 2025 Civic Sport",
        sections: [
          {
            id: "GREETING",
            display_order: 1,
            title: null,
            content: "Dear [Customer Name]",
            variant: "default"
          },
          {
            id: "OPENING_MESSAGE",
            display_order: 2,
            title: null,
            content: "We have an exclusive offer on this 2025 Civic Sport that might interest you.",
            variant: "default"
          },
          {
            id: "CTA_MESSAGE",
            display_order: 3,
            title: null,
            content: "Contact us today to schedule a test drive.",
            variant: "default"
          },
          {
            id: "FOOTER",
            display_order: 4,
            title: null,
            content: "Best regards,<br>Your Dealership Team",
            variant: "default"
          }
        ]
      }
    ],
    messages: [
      {
        role: "user",
        content: "Generate lease offer"
      },
      {
        role: "assistant",
        content: "Got it. I currently have lease offers for the following vehicles. Which one do you want to use it for?"
      },
      {
        role: "user",
        content: "2025 Civic Sport"
      },
      {
        role: "assistant",
        content: "Got it. Here's the opening message I composed:\n\nExperience the perfect blend of sporty design and everyday practicality with the 2025 Honda Civic Hatchback Sport CVT, now available at Honda of Burlington. The 2025 Civic has been recognized by Car and Driver as a 10Best winner, praised for its exceptional value, refined driving dynamics, and top-tier build quality. Right now, lease the 2025 Civic Hatchback Sport CVT for just $265/month*. This limited-time offer provides an affordable way to drive a top-rated compact car. Don't miss out—visit Honda of Burlington today to take advantage of this exceptional deal."
      }
    ]
  },

  // Confirm opening message
  'OM-001': {
    conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
    next_action: "SELECT_VEHICLE_HIGHLIGHT",
    suggestions: [
      {
        id: "VH-001",
        text: "Trade-In"
      },
      {
        id: "VH-002",
        text: "Service Pass"
      },
      {
        id: "VH-003",
        text: "Finance"
      },
      {
        id: "VH-004",
        text: "Dealer Value"
      },
      {
        id: "VH-005",
        text: "Honda Value"
      }
    ],
    is_input_restricted_to_suggestions: true,
    terminal_action: false,
    email_content_preview: [
      {
        subject: "Special Offer on 2025 Civic Sport",
        sections: [
          {
            id: "GREETING",
            display_order: 1,
            title: null,
            content: "Dear [Customer Name]",
            variant: "default"
          },
          {
            id: "OPENING_MESSAGE",
            display_order: 2,
            title: "Opening Message",
            content: "Lease the 2025 Civic Hatchback Sport CVT for just $265/month*.",
            variant: "purple"
          },
          {
            id: "CTA_MESSAGE",
            display_order: 3,
            title: null,
            content: "Contact us today to schedule a test drive.",
            variant: "default"
          },
          {
            id: "FOOTER",
            display_order: 4,
            title: null,
            content: "Best regards,<br>Your Dealership Team",
            variant: "default"
          }
        ]
      }
    ],
    messages: [
      {
        role: "user",
        content: "Generate lease offer"
      },
      {
        role: "assistant",
        content: "Got it. I currently have lease offers for the following vehicles. Which one do you want to use it for?"
      },
      {
        role: "user",
        content: "2025 Civic Sport"
      },
      {
        role: "assistant",
        content: "Got it. Here's the opening message I composed:\n\nExperience the perfect blend of sporty design and everyday practicality with the 2025 Honda Civic Hatchback Sport CVT, now available at Honda of Burlington. The 2025 Civic has been recognized by Car and Driver as a 10Best winner, praised for its exceptional value, refined driving dynamics, and top-tier build quality. Right now, lease the 2025 Civic Hatchback Sport CVT for just $265/month*. This limited-time offer provides an affordable way to drive a top-rated compact car. Don't miss out—visit Honda of Burlington today to take advantage of this exceptional deal."
      },
      {
        role: "user",
        content: "Looks good"
      },
      {
        role: "assistant",
        content: "Great! Which value do you want to highlight?"
      }
    ]
  },

  // Select vehicle highlight
  'VH-001': {
    conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
    next_action: "SELECT_SECONDARY_OFFERS",
    suggestions: [
      {
        id: "DO-001",
        text: "$1000 over KBB Trade-In"
      },
      {
        id: "DO-002",
        text: "$25 gift card for test drive"
      }
    ],
    is_input_restricted_to_suggestions: true,
    terminal_action: false,
    email_content_preview: [
      {
        subject: "Special Offer on 2025 Civic Sport",
        sections: [
          {
            id: "GREETING",
            display_order: 1,
            title: null,
            content: "Dear [Customer Name]",
            variant: "default"
          },
          {
            id: "OPENING_MESSAGE",
            display_order: 2,
            title: "Opening Message",
            content: "Lease the 2025 Civic Hatchback Sport CVT for just $265/month*.",
            variant: "purple"
          },
          {
            id: "TRADE_IN",
            display_order: 3,
            title: "Trade-In",
            content: "Get the best value for your current vehicle.",
            variant: "blue"
          },
          {
            id: "CTA_MESSAGE",
            display_order: 4,
            title: null,
            content: "Contact us today to schedule a test drive.",
            variant: "default"
          },
          {
            id: "FOOTER",
            display_order: 5,
            title: null,
            content: "Best regards,<br>Your Dealership Team",
            variant: "default"
          }
        ]
      }
    ],
    messages: [
      {
        role: "user",
        content: "Generate lease offer"
      },
      {
        role: "assistant",
        content: "Got it. I currently have lease offers for the following vehicles. Which one do you want to use it for?"
      },
      {
        role: "user",
        content: "2025 Civic Sport"
      },
      {
        role: "assistant",
        content: "Got it. Here's the opening message I composed:\n\nExperience the perfect blend of sporty design and everyday practicality with the 2025 Honda Civic Hatchback Sport CVT, now available at Honda of Burlington. The 2025 Civic has been recognized by Car and Driver as a 10Best winner, praised for its exceptional value, refined driving dynamics, and top-tier build quality. Right now, lease the 2025 Civic Hatchback Sport CVT for just $265/month*. This limited-time offer provides an affordable way to drive a top-rated compact car. Don't miss out—visit Honda of Burlington today to take advantage of this exceptional deal."
      },
      {
        role: "user",
        content: "Looks good"
      },
      {
        role: "assistant",
        content: "Great! Which value do you want to highlight?"
      },
      {
        role: "user",
        content: "Trade-In"
      },
      {
        role: "assistant",
        content: "Thanks. Do you want to include any dealership special offers?"
      }
    ]
  },

  // Select secondary offers
  'DO-001': {
    conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
    next_action: "SELECT_DEALER_SPECIAL_OFFER",
    suggestions: [
      {
        id: "DSO-001",
        text: "Accord Lease offer"
      },
      {
        id: "DSO-002",
        text: "CPO Finance Offer"
      },
      {
        id: "DSO-003",
        text: "Trade-In"
      },
      {
        id: "DSO-004",
        text: "CR-V lease offer"
      }
    ],
    is_input_restricted_to_suggestions: true,
    terminal_action: false,
    email_content_preview: [
      {
        subject: "Special Offer on 2025 Civic Sport",
        sections: [
          {
            id: "GREETING",
            display_order: 1,
            title: null,
            content: "Dear [Customer Name]",
            variant: "default"
          },
          {
            id: "OPENING_MESSAGE",
            display_order: 2,
            title: "Opening Message",
            content: "Lease the 2025 Civic Hatchback Sport CVT for just $265/month*.",
            variant: "purple"
          },
          {
            id: "TRADE_IN",
            display_order: 3,
            title: "Trade-In",
            content: "Get the best value for your current vehicle.",
            variant: "blue"
          },
          {
            id: "DEALER_SPECIAL_OFFER",
            display_order: 4,
            title: "Dealership Special",
            content: "$1,000 over KBB for trade-in",
            variant: "green"
          },
          {
            id: "CTA_MESSAGE",
            display_order: 5,
            title: null,
            content: "Contact us today to schedule a test drive.",
            variant: "default"
          },
          {
            id: "FOOTER",
            display_order: 6,
            title: null,
            content: "Best regards,<br>Your Dealership Team",
            variant: "default"
          }
        ]
      }
    ],
    messages: [
      {
        role: "user",
        content: "Generate lease offer"
      },
      {
        role: "assistant",
        content: "Got it. I currently have lease offers for the following vehicles. Which one do you want to use it for?"
      },
      {
        role: "user",
        content: "2025 Civic Sport"
      },
      {
        role: "assistant",
        content: "Got it. Here's the opening message I composed:\n\nExperience the perfect blend of sporty design and everyday practicality with the 2025 Honda Civic Hatchback Sport CVT, now available at Honda of Burlington. The 2025 Civic has been recognized by Car and Driver as a 10Best winner, praised for its exceptional value, refined driving dynamics, and top-tier build quality. Right now, lease the 2025 Civic Hatchback Sport CVT for just $265/month*. This limited-time offer provides an affordable way to drive a top-rated compact car. Don't miss out—visit Honda of Burlington today to take advantage of this exceptional deal."
      },
      {
        role: "user",
        content: "Looks good"
      },
      {
        role: "assistant",
        content: "Great! Which value do you want to highlight?"
      },
      {
        role: "user",
        content: "Trade-In"
      },
      {
        role: "assistant",
        content: "Thanks. Do you want to include any dealership special offers?"
      },
      {
        role: "user",
        content: "$1,000 over KBB for trade-in"
      },
      {
        role: "assistant",
        content: "Excellent! I have included that and it will surely increase customer interest. Last question: Do you want to include any secondary offer images?"
      }
    ]
  },

  // Select dealer special offer
  'DSO-001': {
    conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
    next_action: "GENERATE_EMAIL",
    suggestions: [
      {
        id: "GM-001",
        text: "Done"
      },
      {
        id: "GM-002",
        text: "Find target buyers"
      }
    ],
    is_input_restricted_to_suggestions: true,
    terminal_action: true,
    email_content_preview: [
      {
        subject: "Special Offer on 2025 Civic Sport",
        sections: [
          {
            id: "GREETING",
            display_order: 1,
            title: null,
            content: "Dear [Customer Name]",
            variant: "default"
          },
          {
            id: "OPENING_MESSAGE",
            display_order: 2,
            title: "Opening Message",
            content: "Lease the 2025 Civic Hatchback Sport CVT for just $265/month*.",
            variant: "purple"
          },
          {
            id: "TRADE_IN",
            display_order: 3,
            title: "Trade-In",
            content: "Get the best value for your current vehicle.",
            variant: "blue"
          },
          {
            id: "DEALER_SPECIAL_OFFER",
            display_order: 4,
            title: "Dealership Special",
            content: "$1,000 over KBB for trade-in",
            variant: "green"
          },
          {
            id: "CTA_MESSAGE",
            display_order: 5,
            title: null,
            content: "Contact us today to schedule a test drive.",
            variant: "default"
          },
          {
            id: "FOOTER",
            display_order: 6,
            title: null,
            content: "Best regards,<br>Your Dealership Team",
            variant: "default"
          },
          {
            id: "SECONDARY_OFFER",
            display_order: 7,
            title: "Secondary Offer",
            content: "Accord Lease Offer",
            variant: "orange"
          }
        ]
      }
    ],
    messages: [
      {
        role: "user",
        content: "Generate lease offer"
      },
      {
        role: "assistant",
        content: "Got it. I currently have lease offers for the following vehicles. Which one do you want to use it for?"
      },
      {
        role: "user",
        content: "2025 Civic Sport"
      },
      {
        role: "assistant",
        content: "Got it. Here's the opening message I composed:\n\nExperience the perfect blend of sporty design and everyday practicality with the 2025 Honda Civic Hatchback Sport CVT, now available at Honda of Burlington. The 2025 Civic has been recognized by Car and Driver as a 10Best winner, praised for its exceptional value, refined driving dynamics, and top-tier build quality. Right now, lease the 2025 Civic Hatchback Sport CVT for just $265/month*. This limited-time offer provides an affordable way to drive a top-rated compact car. Don't miss out—visit Honda of Burlington today to take advantage of this exceptional deal."
      },
      {
        role: "user",
        content: "Looks good"
      },
      {
        role: "assistant",
        content: "Great! Which value do you want to highlight?"
      },
      {
        role: "user",
        content: "Trade-In"
      },
      {
        role: "assistant",
        content: "Thanks. Do you want to include any dealership special offers?"
      },
      {
        role: "user",
        content: "$1,000 over KBB for trade-in"
      },
      {
        role: "assistant",
        content: "Excellent! I have included that and it will surely increase customer interest. Last question: Do you want to include any secondary offer images?"
      },
      {
        role: "user",
        content: "Accord Lease Offer"
      },
      {
        role: "assistant",
        content: "Generate Email"
      }
    ]
  }
};

// Mock request examples for testing
export const mockChatRequests: Record<string, ChatRequest> = {
  // Initial request
  'initial': {
    dealer_id: "D001",
    action: "SELECT_OPERATION",
    selected_option: "0",
    messages: [
      {
        role: "user",
        content: "Generate lease offer"
      }
    ],
    new: true
  },

  // Select lease offer
  'select_lease_offer': {
    dealer_id: "D001",
    conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
    action: "SELECT_LEASE_OFFER",
    selected_option: "LO-001",
    messages: [
      {
        role: "user",
        content: "Generate lease offer"
      },
      {
        role: "assistant",
        content: "Got it. I currently have lease offers for the following vehicles. Which one do you want to use it for?"
      },
      {
        role: "user",
        content: "2025 Civic Sport"
      }
    ]
  },

  // Confirm opening message
  'confirm_opening': {
    dealer_id: "D001",
    conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
    action: "CONFIRM_OPENING_MESSAGE",
    selected_option: "OM-001",
    messages: [
      {
        role: "user",
        content: "Generate lease offer"
      },
      {
        role: "assistant",
        content: "Got it. I currently have lease offers for the following vehicles. Which one do you want to use it for?"
      },
      {
        role: "user",
        content: "2025 Civic Sport"
      },
      {
        role: "assistant",
        content: "Got it. Here's the opening message I composed:\n\nExperience the perfect blend of sporty design and everyday practicality with the 2025 Honda Civic Hatchback Sport CVT, now available at Honda of Burlington. The 2025 Civic has been recognized by Car and Driver as a 10Best winner, praised for its exceptional value, refined driving dynamics, and top-tier build quality. Right now, lease the 2025 Civic Hatchback Sport CVT for just $265/month*. This limited-time offer provides an affordable way to drive a top-rated compact car. Don't miss out—visit Honda of Burlington today to take advantage of this exceptional deal."
      },
      {
        role: "user",
        content: "Looks good"
      }
    ]
  },

  // Select vehicle highlight
  'select_vehicle_highlight': {
    dealer_id: "D001",
    conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
    action: "SELECT_VEHICLE_HIGHLIGHT",
    selected_option: "VH-001",
    messages: [
      {
        role: "user",
        content: "Generate lease offer"
      },
      {
        role: "assistant",
        content: "Got it. I currently have lease offers for the following vehicles. Which one do you want to use it for?"
      },
      {
        role: "user",
        content: "2025 Civic Sport"
      },
      {
        role: "assistant",
        content: "Got it. Here's the opening message I composed:\n\nExperience the perfect blend of sporty design and everyday practicality with the 2025 Honda Civic Hatchback Sport CVT, now available at Honda of Burlington. The 2025 Civic has been recognized by Car and Driver as a 10Best winner, praised for its exceptional value, refined driving dynamics, and top-tier build quality. Right now, lease the 2025 Civic Hatchback Sport CVT for just $265/month*. This limited-time offer provides an affordable way to drive a top-rated compact car. Don't miss out—visit Honda of Burlington today to take advantage of this exceptional deal."
      },
      {
        role: "user",
        content: "Looks good"
      },
      {
        role: "assistant",
        content: "Great! Which value do you want to highlight?"
      }
    ]
  },

  // Select secondary offers
  'select_secondary_offers': {
    dealer_id: "D001",
    conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
    action: "SELECT_SECONDARY_OFFERS",
    selected_option: "DO-001",
    messages: [
      {
        role: "user",
        content: "Generate lease offer"
      },
      {
        role: "assistant",
        content: "Got it. I currently have lease offers for the following vehicles. Which one do you want to use it for?"
      },
      {
        role: "user",
        content: "2025 Civic Sport"
      },
      {
        role: "assistant",
        content: "Got it. Here's the opening message I composed:\n\nExperience the perfect blend of sporty design and everyday practicality with the 2025 Honda Civic Hatchback Sport CVT, now available at Honda of Burlington. The 2025 Civic has been recognized by Car and Driver as a 10Best winner, praised for its exceptional value, refined driving dynamics, and top-tier build quality. Right now, lease the 2025 Civic Hatchback Sport CVT for just $265/month*. This limited-time offer provides an affordable way to drive a top-rated compact car. Don't miss out—visit Honda of Burlington today to take advantage of this exceptional deal."
      },
      {
        role: "user",
        content: "Looks good"
      },
      {
        role: "assistant",
        content: "Great! Which value do you want to highlight?"
      },
      {
        role: "user",
        content: "Trade-In"
      },
      {
        role: "assistant",
        content: "Thanks. Do you want to include any dealership special offers?"
      }
    ]
  },

  // Select dealer special offer
  'select_dealer_special': {
    dealer_id: "D001",
    conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
    action: "SELECT_DEALER_SPECIAL_OFFER",
    selected_option: "DSO-001",
    messages: [
      {
        role: "user",
        content: "Generate lease offer"
      },
      {
        role: "assistant",
        content: "Got it. I currently have lease offers for the following vehicles. Which one do you want to use it for?"
      },
      {
        role: "user",
        content: "2025 Civic Sport"
      },
      {
        role: "assistant",
        content: "Got it. Here's the opening message I composed:\n\nExperience the perfect blend of sporty design and everyday practicality with the 2025 Honda Civic Hatchback Sport CVT, now available at Honda of Burlington. The 2025 Civic has been recognized by Car and Driver as a 10Best winner, praised for its exceptional value, refined driving dynamics, and top-tier build quality. Right now, lease the 2025 Civic Hatchback Sport CVT for just $265/month*. This limited-time offer provides an affordable way to drive a top-rated compact car. Don't miss out—visit Honda of Burlington today to take advantage of this exceptional deal."
      },
      {
        role: "user",
        content: "Looks good"
      },
      {
        role: "assistant",
        content: "Great! Which value do you want to highlight?"
      },
      {
        role: "user",
        content: "Trade-In"
      },
      {
        role: "assistant",
        content: "Thanks. Do you want to include any dealership special offers?"
      },
      {
        role: "user",
        content: "$1,000 over KBB for trade-in"
      },
      {
        role: "assistant",
        content: "Excellent! I have included that and it will surely increase customer interest. Last question: Do you want to include any secondary offer images?"
      }
    ]
  }
};

// Helper function to get mock response based on action
export const getMockChatResponse = (action: string): ChatResponse | null => {
  return mockChatResponses[action] || null;
};

// Helper function to get mock request based on key
export const getMockChatRequest = (key: string): ChatRequest | null => {
  return mockChatRequests[key] || null;
};

// Mock conversation flow for testing
export const mockConversationFlow = [
  {
    step: 1,
    action: "SELECT_OPERATION",
    request: mockChatRequests.initial,
    response: mockChatResponses.SELECT_OPERATION,
    description: "Initial operation selection"
  },
  {
    step: 2,
    action: "SELECT_LEASE_OFFER",
    request: mockChatRequests.select_lease_offer,
    response: mockChatResponses.SELECT_LEASE_OFFER,
    description: "Select lease offer vehicle"
  },
  {
    step: 3,
    action: "CONFIRM_OPENING_MESSAGE",
    request: mockChatRequests.confirm_opening,
    response: mockChatResponses.CONFIRM_OPENING_MESSAGE,
    description: "Confirm opening message"
  },
  {
    step: 4,
    action: "SELECT_VEHICLE_HIGHLIGHT",
    request: mockChatRequests.select_vehicle_highlight,
    response: mockChatResponses.SELECT_VEHICLE_HIGHLIGHT,
    description: "Select vehicle highlight value"
  },
  {
    step: 5,
    action: "SELECT_SECONDARY_OFFERS",
    request: mockChatRequests.select_secondary_offers,
    response: mockChatResponses.SELECT_SECONDARY_OFFERS,
    description: "Select secondary offers"
  },
  {
    step: 6,
    action: "SELECT_DEALER_SPECIAL_OFFER",
    request: mockChatRequests.select_dealer_special,
    response: mockChatResponses.SELECT_DEALER_SPECIAL_OFFER,
    description: "Select dealer special offer"
  }
];

// Mock data for Generate Email API
export const mockGenerateEmailResponse: GenerateEmailResponse = {
  generatedHtml: `
    <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Special Offer on 2025 Civic Sport</title>
        <style>
            body {
                font-family: Arial, sans-serif;
                line-height: 1.6;
                color: #333;
                max-width: 600px;
                margin: 0 auto;
                padding: 20px;
                background-color: #f4f4f4;
            }
            .email-container {
                background-color: #ffffff;
                border-radius: 8px;
                padding: 30px;
                box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            }
            .header {
                text-align: center;
                margin-bottom: 30px;
                padding-bottom: 20px;
                border-bottom: 2px solid #e0e0e0;
            }
            .greeting {
                font-size: 16px;
                margin-bottom: 20px;
                color: #555;
            }
            .opening-message {
                background-color: #6a1b9a;
                color: white;
                padding: 20px;
                border-radius: 8px;
                margin: 20px 0;
                text-align: center;
                font-size: 18px;
                font-weight: bold;
            }
            .trade-in-section {
                background-color: #1976d2;
                color: white;
                padding: 20px;
                border-radius: 8px;
                margin: 20px 0;
                text-align: center;
            }
            .dealer-special {
                background-color: #388e3c;
                color: white;
                padding: 20px;
                border-radius: 8px;
                margin: 20px 0;
                text-align: center;
            }
            .secondary-offer {
                background-color: #f57c00;
                color: white;
                padding: 20px;
                border-radius: 8px;
                margin: 20px 0;
                text-align: center;
            }
            .cta-button {
                display: inline-block;
                background-color: #ff6b35;
                color: white;
                padding: 15px 30px;
                text-decoration: none;
                border-radius: 5px;
                font-weight: bold;
                margin: 20px 0;
                text-align: center;
            }
            .footer {
                margin-top: 30px;
                padding-top: 20px;
                border-top: 1px solid #e0e0e0;
                text-align: center;
                color: #666;
                font-size: 14px;
            }
            .disclaimer {
                font-size: 12px;
                color: #888;
                margin-top: 20px;
                text-align: center;
            }
        </style>
    </head>
    <body>
        <div class="email-container">
            <div class="header">
                <h1>Honda of Burlington</h1>
                <h2>Special Offer on 2025 Civic Sport</h2>
            </div>
            
            <div class="greeting">
                Dear [Customer Name],
            </div>
            
            <div class="opening-message">
                <h3>Opening Message</h3>
                Lease the 2025 Civic Hatchback Sport CVT for just $265/month*.
            </div>
            
            <div class="trade-in-section">
                <h3>Trade-In</h3>
                Get the best value for your current vehicle.
            </div>
            
            <div class="dealer-special">
                <h3>Dealership Special</h3>
                $1,000 over KBB for trade-in
            </div>
            
            <div class="secondary-offer">
                <h3>Secondary Offer</h3>
                Accord Lease Offer
            </div>
            
            <div style="text-align: center;">
                <a href="mailto:sales@hondaofburlington.com" class="cta-button">
                    Contact us today to schedule a test drive
                </a>
            </div>
            
            <div class="footer">
                Best regards,<br>
                Your Dealership Team<br><br>
                Honda of Burlington<br>
                123 Main Street<br>
                Burlington, VT 05401<br>
                Phone: (802) 555-0123<br>
                Email: sales@hondaofburlington.com
            </div>
            
            <div class="disclaimer">
                *Lease offer subject to credit approval. Terms and conditions apply. 
                See dealer for complete details. Offer expires 12/31/2024.
            </div>
        </div>
    </body>
    </html>
  `,
  subject: "Special Offer on 2025 Civic Sport",
  conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
  emailPreview: {
    subject: "2026 Chevrolet Equinox Lease Offer Template - Generated by",
    sections: [],
    meta: {
      name: "2026 Chevrolet Equinox Lease Offer Template - Generated by",
      subject: "Lease Offer on 2026 Chevrolet Equinox LT Today",
      template_type: "LEASE_VEHICLE"
    }
  },
  messages: [
    {
      role: "user",
      content: "Generate Lease Offer"
    },
    {
      role: "assistant",
      content: "Alright, pulling in the latest lease programs available at your dealership. I found several great options for you to choose from."
    },
    {
      role: "assistant",
      content: "Lease programs were found at our dealership. Which option would you like to use for your email campaign?"
    },
    {
      role: "user",
      content: "2025.0 HONDA HR-V LX AWD"
    },
    {
      role: "assistant",
      content: "Good choice! The 2025 Honda HR-V LX AWD is a great option! Let me prepare the lease offer details for you."
    },
    {
      role: "user",
      content: "Lease offer 2025.0 HONDA HR-V LX AWD has been selected"
    },
    {
      role: "assistant",
      content: "The lease offer has been successfully selected and loaded into your email template. Your email is now ready to be sent to your target audience!"
    }
  ],
  suggestions: [
    {
      id: "PREVIEW",
      text: "Preview Email"
    },
    {
      id: "save-template",
      text: "Save as Template"
    },
    {
      id: "RESTART",
      text: "Start Over"
    }
  ]
};

// Mock request for Generate Email API
export const mockGenerateEmailRequest: GenerateEmailRequest = {
  dealer_id: "D001",
    conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
  messages: [
    {
      role: "user",
      content: "Generate lease offer"
    },
    {
      role: "assistant",
      content: "Got it. I currently have lease offers for the following vehicles. Which one do you want to use it for?"
    },
    {
      role: "user",
      content: "2025 Civic Sport"
    },
    {
      role: "assistant",
      content: "Got it. Here's the opening message I composed:\n\nExperience the perfect blend of sporty design and everyday practicality with the 2025 Honda Civic Hatchback Sport CVT, now available at Honda of Burlington. The 2025 Civic has been recognized by Car and Driver as a 10Best winner, praised for its exceptional value, refined driving dynamics, and top-tier build quality. Right now, lease the 2025 Civic Hatchback Sport CVT for just $265/month*. This limited-time offer provides an affordable way to drive a top-rated compact car. Don't miss out—visit Honda of Burlington today to take advantage of this exceptional deal."
    },
    {
      role: "user",
      content: "Looks good"
    },
    {
      role: "assistant",
      content: "Great! Which value do you want to highlight?"
    },
    {
      role: "user",
      content: "Trade-In"
    },
    {
      role: "assistant",
      content: "Thanks. Do you want to include any dealership special offers?"
    },
    {
      role: "user",
      content: "$1,000 over KBB for trade-in"
    },
    {
      role: "assistant",
      content: "Excellent! I have included that and it will surely increase customer interest. Last question: Do you want to include any secondary offer images?"
    },
    {
      role: "user",
      content: "Accord Lease Offer"
    },
    {
      role: "assistant",
      content: "Generate Email"
    }
  ]
};

// Mock data for Init API
export const mockInitResponse: InitResponse = {
  conversation_id: "ecadbf89-0abb-4d04-9fc9-01a006160626",
  tracking_id: "decaa57b-b817-47a8-aa00-mock-tracking-id",
  messages: [],
  next_action: "SELECT_OPERATION",
  suggestions: [],
  is_input_restricted_to_suggestions: false,
  terminal_action: false,
  email_content_preview: []
};

// Mock request for Init API
export const mockInitRequest: InitRequest = {
  dealer_id: "63f38f2774fd071f63333055"
};
